import { createTheme } from '@mui/material/styles';
import { color } from './color';

declare module '@mui/material/styles' {
  interface Palette {
    green: typeof color.green;
    red: typeof color.red;
    yellow: typeof color.yellow;
  }
  interface PaletteOptions {
    green?: typeof color.green;
    red?: typeof color.red;
    yellow?: typeof color.yellow;
  }
}

declare module '@mui/material/styles/createPalette' {
  interface TypeText {
    light: string;
    dark: string;
  }
  interface TypeBackground {
    light: string;
    dark: string;
  }
}

const size = {
  mobileSmall: 375,
  mobileMax: 575,
  smTabletMin: 576,
  smTabletMax: 767,
  tabletMin: 768,
  tabletMax: 991,
  desktopMin: 992,
  desktopMax: 1199,
  lgDesktopMin: 1200,
  lgDesktopMax: 1439,
  xlDesktopMin: 1440,
};

export const pittaTheme = createTheme({
  palette: {
    primary: {
      main: color.green.primary,
    },
    secondary: {
      main: color.grey['500'],
    },
    error: {
      main: color.red.dark,
    },
    green: color.green,
    red: color.red,
    yellow: color.yellow,
    grey: color.grey,
    background: {
      default: color.background.light,
      paper: color.background.light,
      light: color.background.light,
      dark: color.background.dark,
    },
    text: {
      primary: color.text.light,
      secondary: color.text.dark,
      light: color.text.light,
      dark: color.text.dark,
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: size.smTabletMin,
      md: size.tabletMin,
      lg: size.desktopMin,
      xl: size.lgDesktopMin,
    },
  },
});
